import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const cancellationPolicyApiConfig = {
  getCancellationPolicies: {
    key: "getCancellationPolicies",
    url: "/api/v1/cancellation-policies",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },
  getDeletedCancellationPolicies: {
    key: "getDeletedCancellationPolicies",
    url: "/api/v1/cancellation-policies/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },
  getCancellationPolicyById: {
    key: "getCancellationPolicyById",
    url: (data) => `/api/v1/cancellation-policies/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },
  createCancellationPolicy: {
    key: "createCancellationPolicy",
    url: "/api/v1/cancellation-policies",
    method: "POST",
    options: {
      invalidateKeys: ["getCancellationPolicies"],
    },
  },
  updateCancellationPolicy: {
    key: "updateCancellationPolicy",
    url: (data) => `/api/v1/cancellation-policies/${data.id}`,
    method: "PATCH",
    options: {
      invalidateKeys: ["getCancellationPolicies"],
    },
  },
  softDeleteCancellationPolicy: {
    key: "softDeleteCancellationPolicy",
    url: (data) => `/api/v1/cancellation-policies/${data.id}`,
    method: "DELETE",
    options: {
      invalidateKeys: ["getCancellationPolicies"],
    },
  },
  restoreCancellationPolicy: {
    key: "restoreCancellationPolicy",
    url: (data) => `/api/v1/cancellation-policies/${data.id}/restore`,
    method: "PATCH",
    options: {
      invalidateKeys: ["getCancellationPolicies"],
    },
  },
  calculateCancellationPenalty: {
    key: "calculateCancellationPenalty",
    url: "/api/v1/cancellation-policies/calculate-penalty",
    method: "POST",
  },
};
